<div class="card-box">
  <div>
    <label style="margin-right: 10px; vertical-align: super"
      ><b>Choose a Patient : </b>
    </label>
    <p-dropdown class="notranslate"
      [(ngModel)]="member_value"
      [options]="members"
      (onChange)="onMemberChange()"
    >
    </p-dropdown>
  </div>
</div>
<div class="row col-md-12 card-box">
  <span class="p-buttonset">
    <button
      type="button"
      pButton
      label="Inbox"
      icon="pi pi-fw pi-inbox"
      (click)="this.TabSwitch(false)"
      [disabled]="!sentEnabled"
    ></button>
    <button
      type="button"
      pButton
      label="Sent"
      icon="pi pi-fw pi-reply"
      (click)="this.TabSwitch(true)"
      [disabled]="sentEnabled"
    ></button>
  </span>
  <div style="float: right">
    <button
      type="button"
      pButton
      [routerLink]="['/', this.slug, 'patient', 'compose-email']"
      label="Compose Email"
    ></button>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <div
      class="card-box"
      style="
        background-color: white;
        border-top-right-radius: 0px;
        border-top-left-radius: 0px;
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 0px;
      "
    >
      <p-menubar [model]="items">
        <i
          class="fa fa-refresh"
          style="
            cursor: pointer;
            margin-left: 3px;
            margin-right: 3px;
            font-size: 1.3rem;
          "
          pTooltip="Refresh"
          tooltipPosition="top"
          *ngIf="!MailChecking"
          (click)="GetUpdates()"
        ></i>
        <p-progressSpinner
          [style]="{ width: '25px', height: '25px' }"
          *ngIf="MailChecking"
          strokeWidth="7"
        >
        </p-progressSpinner>

        <i
          class="pi pi-chevron-left"
          (click)="prevPage()"
          pTooltip="Previous Page"
          style="cursor: pointer"
        ></i>
        <i
          class="pi pi-chevron-right"
          (click)="nextPage()"
          pTooltip="Next Page"
          style="cursor: pointer"
        ></i>
      </p-menubar>

      <div class="justify-content-center">
        <p-table
          #dt
          [value]="messages"
          [rows]="10"
          [globalFilterFields]="['Date', 'From', 'Subject']"
          [rowHover]="true"
          dataKey="id"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [showCurrentPageReport]="true"
          [totalRecords]="total_message_count"
          [paginator]="false"
        >
          <ng-template pTemplate="header">
            <tr class="table-text">
              <th style="width: 15%; text-align: center">
                <input
                  type="checkbox"
                  (click)="selectALL()"
                  [value]="selected"
                  [(ngModel)]="selected"
                />
              </th>
              <th style="width: 15%; text-align: center">
                <span
                  ><i class="pi pi-star" style="color: rgb(250, 192, 3)"></i
                ></span>
              </th>

              <th>
                <b class="notranslate">{{ sentEnabled ? 'To' : 'From' }}</b>
              </th>

              <th><b>Subject</b></th>

              <th><b>Date</b></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-m>
            <tr class="table-text">
              <td>
                <input
                  type="checkbox"
                  class="checkmail"
                  [value]="m.selected"
                  [(ngModel)]="m.selected"
                  (click)="select(m.id)"
                />
              </td>
              <td
                (click)="
                  MailViewNavigation(m.patient_guid, m.message_id, m.user_guid)
                "
              >
                <span class="custom-nav-link">
                  <i
                    class="pi pi-star"
                    *ngIf="m.flagged == true"
                    style="color: rgb(250, 192, 3)"
                  ></i>
                  <i
                    class="pi pi-star-o"
                    *ngIf="m.flagged == false"
                    style="color: rgb(250, 192, 3)"
                  ></i>
                </span>
              </td>
              <td
                [style.font-weight]="m.read ? 300 : 600"
                class="custom-nav-link"
                (click)="
                  MailViewNavigation(m.patient_guid, m.message_id, m.user_guid)
                "
              >
                {{ sentEnabled ? m.to : m.from }}
              </td>

              <td
                [style.font-weight]="m.read ? 300 : 600"
                class="custom-nav-link"
                (click)="
                  MailViewNavigation(m.patient_guid, m.message_id, m.user_guid)
                "
              >
                {{ m.subject }}
              </td>

              <td
                [style.font-weight]="m.read ? 300 : 600"
                class="custom-nav-link"
                (click)="
                  MailViewNavigation(m.patient_guid, m.message_id, m.user_guid)
                "
              >
                {{ m.date | customdateformat }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<div class="row justify-content-center">
  <p style="text-align: center">
    Showing
    {{ total_message_count == 0 ? 0 : messages_per_page * (page_no - 1) + 1 }} -
    {{ minFn(messages_per_page * page_no, total_message_count) }} of
    {{ total_message_count }}
  </p>
</div>

<div
  *ngIf="response.success != null && response.success == false"
  class="alert alert-danger"
>
  <p *ngIf="response.error != null">{{ response.error.message }}</p>
  <div *ngIf="serverError.error != null && serverError.statusCode != 500">
    <p *ngFor="let message of serverError.message">{{ message }}</p>
  </div>
  <div *ngIf="serverError.error != null && serverError.statusCode == 500">
    <p>{{ serverError.message }}</p>
  </div>
</div>
